import { useFormContext, useWatch } from 'react-hook-form';

import { useQuickQuoteContext } from '../context/QuickQuoteContext';
import { LTLQuote, QuickQuoteInputs } from '../types';
import { getLTLQuoteIdentity } from '../util';
import { LTLQuoteResultsView } from './LTLQuoteResultsView';

interface LTLQuoteResultsLocalProps {
  onSelectQuote: (quote: LTLQuote) => void;
  isActiveTaiLtlIntegration?: boolean;
}

// Single Quick Quote results: the shared results view fed from QuickQuoteContext.
export function LTLQuoteResults({
  onSelectQuote,
  isActiveTaiLtlIntegration = false,
}: LTLQuoteResultsLocalProps) {
  const { control } = useFormContext<QuickQuoteInputs>();
  const shiplifyLookups = useWatch({
    control,
    name: 'ltl.shiplifyLookups',
  });
  const {
    ltlQuotes,
    selectedLTLQuotes,
    ltlExternalQuoteURL,
    ltlExternalQuoteID,
    ltlExternalQuoteSource,
    ltlExternalQuoteLabel,
    ltlExternalQuoteStatus,
    ltlExternalQuoteErrorMessage,
    ltlExternalQuoteAssignment,
  } = useQuickQuoteContext();

  return (
    <LTLQuoteResultsView
      quotes={ltlQuotes}
      selectedQuoteIds={selectedLTLQuotes.map(getLTLQuoteIdentity)}
      externalQuote={{
        url: ltlExternalQuoteURL,
        id: ltlExternalQuoteID,
        source: ltlExternalQuoteSource,
        label: ltlExternalQuoteLabel,
        status: ltlExternalQuoteStatus,
        errorMessage: ltlExternalQuoteErrorMessage,
        assignment: ltlExternalQuoteAssignment,
      }}
      shiplifyLookups={shiplifyLookups}
      onSelectQuote={onSelectQuote}
      isActiveTaiLtlIntegration={isActiveTaiLtlIntegration}
    />
  );
}
